import * as React from "react";
import {Link, Redirect} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import assets from '../../assets';

class Footer extends React.Component {
    render() {
        return (
            <footer>
                <div className='container'>
                    <div className="social">
                        <ul>
                            <li><a target="_blank" className="fb" href="https://www.facebook.com/rozpoctisito/"><FontAwesomeIcon icon={['fab', 'facebook-f']}/></a></li>
                            <li><a target="_blank" className="yt" href="https://www.youtube.com/channel/UCiV7Qd4KuY_BwUdbXNi6wzQ"><FontAwesomeIcon icon={['fab', 'youtube']}/></a></li>
                        </ul>
                    </div>
                    <div className="footer-info">
                        <div id='footer-guy'/>
                        <p className="small font-weight-bold">Copyright © 2018 yourchance<br/>Created by Luducrafts</p>
                        <p>Kontaktujte nás: <a href='mailto:rozpoctisito@gmail.com'>rozpoctisito@gmail.com</a></p>
                        <div className="clearfix"/>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
